import { render } from "./App.vue?vue&type=template&id=a8a716f2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=a8a716f2&lang=scss"

import exportComponent from "C:\\LeoWizard\\Senior\\Repos\\01_MyPage\\pagedemo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__